import { mediaAssets } from './media.js'
import { sendGoal } from './analytics.js'
import './alex.css'

const ALEX_FORM = 'https://forms.fleet.yandex.ru/forms?ref_id=fba1ef2e691240ceae4388fd1a10c072'

const routes = [
  {
    id: 'delivery',
    kicker: 'Пешком · велосипед · авто',
    title: 'Работать курьером',
    text: 'Заказы в Яндекс Доставке, моментальные выплаты и помощь Александра с подключением.',
    image: mediaAssets.courier,
    position: '69% 43%',
    button: 'Подключиться к доставке',
  },
  {
    id: 'taxi',
    kicker: 'Своё авто · самозанятость',
    title: 'Работать в такси',
    text: 'Подключение к заказам через парк ABG. Выплаты моментальные; Александр поможет пройти первые шаги.',
    image: mediaAssets.taxiSpb,
    position: '63% 45%',
    button: 'Подключиться к такси',
  },
]

export default function AlexLanding() {
  function markClick(route) {
    sendGoal('alex_form_click', { route })
  }

  function markCall(place) {
    sendGoal('alex_contact_click', { place })
  }

  return (
    <div className="alex-page">
      <section className="alex-intro">
        <p className="eyebrow">Парк ABG · поможет Александр</p>
        <h1>Курьером или в такси?<br /> <span>Начни с ABG.</span></h1>
        <p className="alex-intro__lead">Выбери доставку или такси, заполни форму Яндекса и пройди шаги в Яндекс Про. Выплаты в ABG моментальные. Если застрянешь, Александр поможет разобраться.</p>
        <a className="alex-intro__cta" href="#alex-route-title">Выбрать доставку или такси <span aria-hidden="true">↓</span></a>
        <div className="alex-intro__benefits" aria-label="Что даёт подключение">
          <span>Официальная форма Яндекса</span>
          <span>Помощь после заявки</span>
        </div>
        <p className="alex-intro__contact">Есть вопрос до регистрации? Позвони Александру: <a href="tel:+79313214324" onClick={() => markCall('intro')}>+7 931 321-43-24</a></p>
        <p className="alex-intro__note">Самозанятости нет? Для доставки есть <a href="/dostavka">другой способ подключения</a>. В такси через ABG нужна самозанятость.</p>
      </section>

      <section className="alex-routes" aria-labelledby="alex-route-title">
        <h2 id="alex-route-title">Что хочешь делать?</h2>
        <div className="alex-routes__grid">
          {routes.map(route => (
            <a
              key={route.id}
              href={ALEX_FORM}
              target="_blank"
              rel="noopener noreferrer"
              className="alex-teaser"
              style={{ '--alex-image': `url("${route.image.src}")`, '--alex-position': route.position }}
              onClick={() => markClick(route.id)}
              aria-label={route.button + ' — откроется форма Яндекса'}
            >
              <span className="alex-teaser__shade" aria-hidden="true" />
              <span className="alex-teaser__content">
                <span className="alex-teaser__kicker">{route.kicker}</span>
                <strong>{route.title}</strong>
                <span className="alex-teaser__text">{route.text}</span>
                <span className="alex-teaser__button">{route.button} <span aria-hidden="true">↗</span></span>
              </span>
            </a>
          ))}
        </div>
        <p className="alex-routes__caption">Обе кнопки открывают форму Яндекса для подключения к парку ABG. Заполняй её с тем номером телефона, который используешь в Яндекс Про.</p>
      </section>

      <section className="alex-after" aria-labelledby="alex-after-title">
        <div className="alex-after__photo"><img src={mediaAssets.profileCheck.src} alt={mediaAssets.profileCheck.alt} loading="lazy" /></div>
        <div className="alex-after__copy">
          <p className="eyebrow">Лена подсказывает</p>
          <h2 id="alex-after-title">Отправил заявку — что дальше?</h2>
          <ol>
            <li>Открой приложение Яндекс Про с тем же номером телефона. Там будут заказы и дальнейшие шаги.</li>
            <li>Проверь, появился ли парк ABG logist для доставки или ABG Taxi для такси.</li>
            <li>Добавь документы и пройди проверки, которые покажет приложение. После этого сможешь выйти на заказы.</li>
          </ol>
          <p className="alex-after__answer">Не видишь парк или не понимаешь следующий шаг? <a href="tel:+79313214324" onClick={() => markCall('after_form')}>Позвони Александру: +7 931 321-43-24</a>. Скажи, что заполнил форму и на каком шаге остановился. Повторно отправлять заявку не нужно.</p>
        </div>
      </section>

      <section className="alex-trust">
        <h2>Готов начать?</h2>
        <p>Выбери доставку или такси и заполни форму. Сама заявка не включает заказы сразу: сначала нужно пройти шаги в Яндекс Про. Условия подключения и удержания уточни у Александра до первого заказа.</p>
        <a href={ALEX_FORM} target="_blank" rel="noopener noreferrer" className="alex-trust__cta" onClick={() => markClick('final')}>Подать заявку на подключение ↗</a>
      </section>
    </div>
  )
}
